const defaultVTooltipProps = {
  openDelay: 400,
  transition: 'fade-transition',
  maxWidth: '20rem',
  zIndex: '100',
}

const defaultDenseButtonProps = { dense: true, depressed: true, class: 'border', style: 'min-width: 3.5rem;' }

export { defaultVTooltipProps, defaultDenseButtonProps }
